module.exports = require('./helpers/bundle-url').getBundleURL('hdhZv') + "walnut-cove-abstract-hamilton-1.a6862988.jpg";